import React from 'react';
import Button from '@mui/material/Button';
import VolumeUpRounded from '@mui/icons-material/VolumeUpRounded';
import './miniTaskReplayButton.css';

// Target audio only. Instruction playback and audio gates belong to the game.
export default function MiniTaskReplayButton({ label, onClick, disabled = false, tone = 'pastel', className = '' }) {
  return <Button type="button" aria-label={label} disabled={disabled} onClick={onClick}
    className={`mini-task-replay-button${tone === 'filled' ? ' mini-task-replay-button--filled' : ''} ${className}`}>
    <VolumeUpRounded />
  </Button>;
}
